import script from "./DoctorInfoPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./DoctorInfoPopup.vue?vue&type=script&setup=true&lang=ts"

import "./DoctorInfoPopup.vue?vue&type=style&index=0&id=24313e12&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24313e12"]])

export default __exports__